export const colors = {
  primary50: '#0E3E25',
  primary100: '#082A1A',
  primary200: '#031F14',
  secondary: '#E9C447',
};
